
export default {
  name: 'AppSpin',
  props: {
    width: {
      type: Number,
      default: 16, // Valor padrão para a largura
    },
    height: {
      type: Number,
      default: 16, // Valor padrão para a altura
    },
  },
  computed: {
    spinnerClass() {
      return `border-8 border-t-[#09408C] border-blue-100 animate-spin color-[#09408C] rounded-full w-${this.width} h-${this.height}`
    },
  },
}
